import { render, staticRenderFns } from "./insertInternalFundsTransfer.vue?vue&type=template&id=fba54c4a&"
import script from "./insertInternalFundsTransfer.vue?vue&type=script&lang=js&"
export * from "./insertInternalFundsTransfer.vue?vue&type=script&lang=js&"
import style0 from "./insertInternalFundsTransfer.vue?vue&type=style&index=0&id=fba54c4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports